import { render, staticRenderFns } from "./CategoryTab.vue?vue&type=template&id=fc0e298e&scoped=true&"
import script from "./CategoryTab.vue?vue&type=script&lang=js&"
export * from "./CategoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0e298e",
  null
  
)

export default component.exports